When the state took effect.
